<template>
  <div>
    <loader v-if="loader" />
    <div v-else>
      <v-toolbar flat color="white" class="mb-4">
        <v-toolbar-title>{{ formTitle }}</v-toolbar-title>
        <v-divider class="mx-2" inset vertical></v-divider>
        <v-spacer></v-spacer>
        <v-btn @click="$router.go(-1)" class="primary">{{
          $t("button.newsBack")
        }}</v-btn>
      </v-toolbar>
      <form-wrapper :validator="$v.form">
        <v-card>
          <v-form @submit.prevent="handleSubmit">
            <v-container>
              <v-row>
                <v-col cols="12" sm="6" class="mx-auto" v-if="isEdit">
                  <locale-select
                    v-model="locale"
                    @change="handleChangeLocale"
                  />
                </v-col>

                <v-col cols="12">
                  <h2 class="mb-2 my-3">
                    {{ $t("headings.main_photo") }}
                    <sup>*</sup>
                  </h2>
                  <new-image-upload
                    class="file-upload__image"
                    :imgUrl="form.main_media && form.main_media.path"
                    @fileSelected="onFileChange"
                    :maxSize="mainMediaSize"
                    :checkRatio="false"
                    :imgId="form.main_media && form.main_media.id"
                  />
                  <p v-if="imgErorr" class="img_error">
                    {{ $t("validation.image_required") }}
                  </p>
                </v-col>
                <v-col cols="12">
                  <image-upload
                    multiple
                    dense
                    :label="$t('media')"
                    :form="form"
                    fieldName="media"
                    :maxSize="maxSize"
                  />
                </v-col>
                <v-col cols="12">
                  <input-feild
                    v-model="form.title"
                    validateName="title"
                    :v="$v.form.title"
                  ></input-feild>
                </v-col>
                <v-col cols="12" lg="6">
                  <v-select
                    outlined
                    dense
                    :loading="loadingCategories"
                    :label="$t('labels.category')"
                    v-model="form.category"
                    :items="categories"
                    item-text="name"
                    item-value="id"
                  ></v-select>
                </v-col>
                <v-col cols="12">
                  <CustomEditor
                    :placeholder="$t('fields.description')"
                    class="editor"
                    :form="form"
                    fieldName="description"
                  />
                </v-col>

                <v-col sm="6">
                  <input-feild
                    v-model="form.source"
                    validateName="source"
                    :v="$v.form.source"
                  ></input-feild>
                </v-col>
                <v-col cols="12" sm="6">
                  <input-feild
                    v-model="form.source_url"
                    validateName="source_url"
                    :v="$v.form.source_url"
                  ></input-feild>
                </v-col>

                <!-- </v-col> -->
                <!-- rightSide -->

                <v-col cols="12">
                  <v-btn
                    large
                    block
                    :disabled="$v.form.$invalid"
                    type="submit"
                    class="primary"
                    :loading="loading"
                  >
                    {{ saveButton }}</v-btn
                  ></v-col
                >
              </v-row>
            </v-container>
          </v-form>
        </v-card>
      </form-wrapper>
      <v-dialog v-model="errorDialog" max-width="300">
        <v-card>
          <v-card-text class="subheading">
            <h4>{{ errorText }}</h4>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn @click="errorDialog = false" flat>Got it!</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import { maxWords } from "@/utils/validate";
import { IndexData } from "@/helpers/apiMethods";
import {
  required,
  maxLength,
  minLength,
  url,
  requiredIf
} from "vuelidate/lib/validators";
import { storeNews, showNews, updateNews } from "@/api/news.js";

export default {
  name: "create_news",
  components: {
    InputFeild: () => import("@/components/InputFeild"),
    TextAreaFeild: () => import("@/components/TextAreaFeild"),
    VideoUpload: () => import("@/components/VideoUpload")
  },

  validations() {
    return this.validationsRules();
  },
  data() {
    return {
      isEdit: false,
      form: {
        title: "",
        category: "",
        description: "",
        source: "",
        source_url: "",
        main_media: {},
        media: []
      },
      tags: [],
      categories: [],
      itemsTags: [],
      imgErorr: false,
      change: true,
      mainMediaSize: 2,
      maxSize: 1.24,
      errorDialog: null,
      errorText: "",
      loading: false,
      loader: true,
      loadingCategories: true,
      locale: this.locale,

      videos: [],
      imgsUrl: [],
      videoUrl: []
    };
  },
  computed: {
    formTitle() {
      return !this.isEdit
        ? this.$t("headings.create")
        : this.$t("headings.edit");
    },
    saveButton() {
      return !this.isEdit ? this.$t("button.save") : this.$t("button.edit");
    }
  },

  methods: {
    async getCategories() {
      const res = await IndexData({
        reqName: "post-categories",
        query: { pagination: "all" }
      });
      const { post_categories } = res.data;
      this.categories = post_categories;
      this.loadingCategories = false;
    },
    onFileChange({ file }) {
      this.form.main_media = file;
    },

    handleChangeLocale(locale) {
      this.locale = locale;
      this.handleShow(this.$route.params.slug, locale);
    },

    onCreate(data) {
      storeNews(data)
        .then(() => this.$router.push("/posts/list"))
        .finally(() => (this.loading = false));
    },
    onUpdate(data) {
      updateNews(data, this.$route.params.slug)
        .then(() => this.$router.push("/posts/list"))
        .finally(() => (this.loading = false));
    },
    handleSubmit() {
      this.loading = true;
      if (!this.isEdit) {
        // in case Create
        this.onCreate(this.generateData());
      } else {
        // in case update
        this.onUpdate(this.generateData());
      }
    },
    generateData() {
      const formatData = new FormData();
      if (this.isEdit) {
        delete this.form.main_media;
        formatData.append("locale", this.locale);
        formatData.append("_method", "put");
      }
      for (const key in this.form) {
        if (this.form[key] !== "" && key !== "media") {
          formatData.append(key, this.form[key]);
        }
      }

      this.form.media &&
        this.form.media.forEach((photo, index) => {
          if (typeof photo === "object" && !photo.id) {
            formatData.append(`media[${index}]`, photo);
          }
        });
      // this.videos &&
      //   this.videos.forEach((video, index) => {
      //     formatData.append(`videos[${index}]`, video);
      //   });
      return formatData;
    },
    handleShow(slug, locale) {
      showNews(slug, locale).then(res => {
        const { post } = res.data;
        const {
          title,
          description,
          main_media,
          media,
          source,
          source_url,
          tags,
          category
        } = post;

        this.form.category = category && category.id;
        this.form.main_media = main_media;
        this.form.title = title;
        this.form.description = description;
        this.form.source = source || "";
        this.form.source_url = source_url || "";

        this.tags = tags.map(el => el.id);

        this.form.media = media;
      });
    },

    validationsRules() {
      return {
        form: {
          main_media: {
            required
          },
          title: {
            required,
            maxLength: maxLength(200),
            minLength: minLength(3)
          },
          description: {
            required
          },

          source: {
            required: requiredIf(nasted => {
              return nasted.source_url !== null && nasted.source_url !== "";
            })
          },
          source_url: {
            url,
            required: requiredIf(nasted => {
              return nasted.source !== null && nasted.source !== "";
            })
          }
        }
      };
    }
  },
  mounted() {
    this.loader = false;
    this.getCategories();
  },
  watch: {
    locale: {
      handler() {},
      immediate: true
    },
    $route: {
      handler({ params }) {
        if (params.slug) {
          this.isEdit = true;
          this.handleShow(params.slug);
        } else {
          this.isEdit = false;
        }
      },
      immediate: true
    }
  }
};
</script>
